/**
 * Helper function to deal with the fact that sometimes urls can have mobile, resp routing
 * segments.
 */
export const stripRoutingSegment = (uri: string): string => {
    return uri.replace(/^\/(mobile|resp)/, '');
};
